import React from 'react'
import {Featured} from "../data/Data";
import './property.css'
function proporty() {
    console.log("this is your data",{Featured});
    
  return (
    <div className='paddings propertyContainer'>
        <h1 className='primaryText'>Featured Property Types</h1>
        <p className='secondaryText'>Find All Type of Property.</p>
        <div className="paddings propertyCarde">
            {Featured.map((item,index)=>(
                <div className='onlyCrade' key={index}>
                    <img src={item.cover} alt={item.name} />
                    <h1>{item.name}</h1>
                    <p className='secondaryText'>{item.total}</p>
                </div>
            ))}
        </div>
    </div>
  )
}

export default proporty
